import styled from '@emotion/styled';
import { breakpoint, colors, spacing } from 'component-library';

export const BranchInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xsmall};
`;
export const BranchCardRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;

  @media (max-width: ${breakpoint.medium}px) {
    flex-direction: column;
    gap: ${spacing.xsmall};
  }
`;
export const BranchCardInnerColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  p:first-of-type {
    color: ${colors.primary.grey};
  }
`;
